import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { router } from './router';
import { queryClient } from './lib/query-client';
import { auth } from './lib/firebase';
import { appConfig } from './lib/env';
import './index.css';

// Apply environment class for per-environment styling (e.g. background tint)
document.documentElement.classList.add(`env-${appConfig.environment}`);

// Expose Firebase auth for E2E tests
// Available in all environments to support E2E testing against deployed environments
(window as any).firebaseAuth = auth;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider defaultTheme="system" storageKey="heapster-theme">
          <AuthProvider>
            <RouterProvider router={router} />
            <ReactQueryDevtools initialIsOpen={false} />
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
);
